import React, { useMemo } from 'react';

import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import PasswordResetContainer from './PasswordResetContainer';

const ErrorContainer = styled.div`
    margin-bottom: 2rem;
`;

export interface PasswordErrorProps {}

const PasswordError: React.FC<PasswordErrorProps> = () => {
    const { passwordError, isValidToken } = useContainer(PasswordResetContainer);
    const { t } = useTranslation('password_reset');

    const errorMessage = useMemo(() => {
        if (!isValidToken) return t('errors.token-expired');
        if (passwordError) return t('errors.generic');
        return null;
    }, [isValidToken, passwordError, t]);

    if (!errorMessage) return null;

    return (
        <ErrorContainer>
            <Alert severity="error">{errorMessage}</Alert>
        </ErrorContainer>
    );
};

export default PasswordError;
